import { axiosInstance } from '@/shared/api/instance';
import type {
  SubscriptionPlan,
  MySubscription,
  SubscriptionUsageRecord,
  CanUseSubscriptionResponse,
  FreezeInfo,
  FreezeResponse,
  UnfreezeResponse,
  FreezeHistoryRecord,
} from './subscriptions.types';

export const subscriptionsApi = {
  /**
   * Get all active subscription plans
   */
  getPlans: async (): Promise<SubscriptionPlan[]> => {
    const { data } = await axiosInstance.get<SubscriptionPlan[]>('/app/subscriptions/plans');
    return data;
  },

  /**
   * Get current player's subscription
   */
  getMySubscription: async (): Promise<MySubscription | null> => {
    const { data } = await axiosInstance.get<MySubscription | null>('/app/subscriptions/my');
    return data;
  },

  /**
   * Check if current player can use subscription for booking
   */
  canUse: async (): Promise<CanUseSubscriptionResponse> => {
    const { data } = await axiosInstance.get<CanUseSubscriptionResponse>('/app/subscriptions/can-use');
    return data;
  },

  /**
   * Get subscription usage history
   */
  getHistory: async (): Promise<SubscriptionUsageRecord[]> => {
    const { data } = await axiosInstance.get<SubscriptionUsageRecord[]>('/app/subscriptions/history');
    return data;
  },

  /**
   * Get freeze information for subscription
   */
  getFreezeInfo: async (): Promise<FreezeInfo | null> => {
    const { data } = await axiosInstance.get<FreezeInfo | null>('/app/subscriptions/freeze-info');
    return data;
  },

  /**
   * Freeze subscription indefinitely until manual unfreeze
   */
  freeze: async (reason?: string): Promise<FreezeResponse> => {
    const params = reason ? new URLSearchParams({ reason }) : undefined;
    const url = params ? `/app/subscriptions/freeze?${params.toString()}` : '/app/subscriptions/freeze';
    const { data } = await axiosInstance.post<FreezeResponse>(url);
    return data;
  },

  /**
   * Unfreeze subscription early
   */
  unfreeze: async (): Promise<UnfreezeResponse> => {
    const { data } = await axiosInstance.post<UnfreezeResponse>('/app/subscriptions/unfreeze');
    return data;
  },

  /**
   * Get freeze history
   */
  getFreezeHistory: async (): Promise<FreezeHistoryRecord[]> => {
    const { data } = await axiosInstance.get<FreezeHistoryRecord[]>('/app/subscriptions/freeze-history');
    return data;
  },
};
